import { toast } from "react-toastify";
import API from "./../../helpers/api/api_interceptor";
import { EDIT_PERMISSOINS, GET_PERMISSOINSLIST } from "./actionType";

// list all permissoins
export const getPermissions = (params) => async (dispatch) => {
  try {
    return API.get(`/users/permissions`, {
      params: {
        page_number: params.page,
        page_size: params.limit,
        search: params.search,
        filter: params.filter,
        sort: params.sort,
      },
    }).then((res) => {
      if (res && res.status && res.status === 200) {
        dispatch({
          type: GET_PERMISSOINSLIST,
          payload: {
            data: res?.data?.data?.results,
            total: res?.data?.data?.count,
          },
        });
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

// Edit Permissoins
export const editPermission =
  ({ id, values }) =>
  async (dispatch) => {
    try {
      return API.put(`/users/permissions/${id}`, values).then((res) => {
        toast.success(res?.data?.detail);
        if (res && res.status && res.status === 200) {
          dispatch({
            type: EDIT_PERMISSOINS,
            payload: {
              data: res?.data?.data,
            },
          });
          return true;
        } else {
          return false;
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
